<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="font-family:Ariel">Dedication</h1>
<p style="text-align: center;">To my sons Ashley and Kerry, who always encourage me; to my daughter Alana, who always laughs with me; and to my grandchildren, who inspire hope for the future.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?19f29cc2